import { render } from "./index.vue?vue&type=template&id=70a1feb2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=70a1feb2&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=70a1feb2&lang=scss"

import exportComponent from "D:\\workspace\\qfy-all\\qfy-oms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a1feb2"]])

export default __exports__